import { environment } from "src/environments/environment"
import { BusinessBanking } from "./BusinessBanking.interface"

export const INITIAL_BUSINESS_BANKING: BusinessBanking = (environment.mock && environment.mockBusinessBanking) ? {
  accountOwner: "Leia Organa",
  iban: "DE02500105170137075030",
  bic: "INGDDEFFXXX",
  creditInstitution: "ING",
  authorize: true
} : {
    accountOwner: "",
    iban: "",
    bic: "",
    creditInstitution: "",
    authorize: false
}
